import Trello from "../Single-task/Trello";

function SinglePlayground() {
  return <Trello />;
}

export default SinglePlayground;
